<template>
<div class="chapter">
<div class="inner_page">
<p class="epit"><a id="epigraph"></a><a id="page_vii">Who looks at Lee must think of Washington;</a></p><a id="page_vii">
<p class="epi">In pain must think, and hide the thought,</p>
<p class="epi">So deep with grievous meaning it is fraught.</p>
</a><p class="epia"><a id="page_vii">—Herman Melville, “Lee in the Capitol”</a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?44d8b664